import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import tinycolor from 'tinycolor2';
import Chip from '@mui/material/Chip';
import { red, green, blue, yellow, pink, cyan, grey } from '@mui/material/colors';
import { formatSurchargeHours } from '../../surchargeUtils';

function getColor(weekday) {
    const colors = {
      'Monday': red[500], // Red
      'Tuesday': green[500], // Green
      'Wednesday': blue[500], // Blue
      'Thursday': yellow[500], // Yellow
      'Friday': pink[500], // Magenta
      'Saturday': cyan[500], // Cyan
      'Sunday': grey[500], // White
    };
  
    return colors[weekday] || grey[500]; // Default color (gray) if day is not recognized
  }
  

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: (props) => getColor(props.weekday),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: theme.palette.getContrastText(grey[50]),
  },
}));


function WeekdayChip({ weekday, hours }) {
    const classes = useStyles({ weekday });
    const hoursLabel = formatSurchargeHours(hours);
  
    return (
      <Chip
        label={hoursLabel ? `${weekday} ${hoursLabel}` : weekday}
        className={classes.root}
        // Let a day's hours wrap on narrow screens instead of being cut off.
        sx={{ height: 'auto', minHeight: 32, maxWidth: '100%', '& .MuiChip-label': { whiteSpace: 'normal', py: 0.5 } }}
      />
    );
  }

function SurchargeWeekday(props) {
//   const classes = useStyles();

  return (
    <div>
       {props.weekdays.map((weekday, index) => <WeekdayChip key={index} weekday={weekday} hours={props.weekdayHours && props.weekdayHours[weekday]} />)}
    </div>
  );
}

const surchargeHoursShape = PropTypes.shape({
  startTime: PropTypes.string,
  endTime: PropTypes.string,
});

WeekdayChip.propTypes = {
  weekday: PropTypes.string.isRequired,
  hours: surchargeHoursShape,
};

SurchargeWeekday.propTypes = {
  weekdays: PropTypes.arrayOf(PropTypes.string).isRequired,
  weekdayHours: PropTypes.objectOf(surchargeHoursShape),
};

export default SurchargeWeekday;